module.exports = __webpack_public_path__ + "static/media/background.5a86417d.jpg";